/**
 * NOS-263: The one way to turn a caught unknown into a user-facing message.
 * Replaces the per-site `err instanceof Error ? err.message : "..."` ternary.
 */
export function errorMessage(err: unknown, fallback = "Something went wrong"): string {
  return err instanceof Error ? err.message : fallback
}
